import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import * as _ from "lodash";
import { Request } from "./request";
import { URLS } from "../constants/url.constants";
import { map } from "rxjs/operators";
import { HttpClient, HttpHeaders, HttpRequest } from "@angular/common/http";

@Injectable({
  providedIn: "root",
})
export class MasterService {
  constructor(
    private request: Request,
    private http: HttpClient,
  ) {
  }


  getMasterBySlugList(slug, patient_id?: any, order_by?: string): Observable<any> {
    let url = URLS.master.getMasterBySlugList;
    url = _.replace(url, "{slug}", slug);
    url = _.replace(url, "{name}", order_by ? order_by : 'name');
    url = _.replace(url, "{patient_id}", patient_id ? patient_id : '');
    return this.request.getApi(url);
  }

  getMasterBySlugFirst(slug, patient_id?: any): Observable<any> {
    let url = URLS.master.getMasterBySlugFirst;
    url = _.replace(url, "{slug}", slug);
    url = _.replace(url, "{patient_id}", patient_id ? patient_id : '');
    return this.request.getApi(url);
  }


  getMasterByAttrList(slug, with_values?: any, patient_id?: any): Observable<any> {
    let url = URLS.master.getMasterByAttrList;
    url = _.replace(url, "{slug}", slug);
    url = _.replace(url, "{w_val}", with_values ? with_values : '');
    url = _.replace(url, "{patient_id}", patient_id ? patient_id : '');
    return this.request.getApi(url);
  }


  getMasterBySlugnAttrList(masterSlug, slug, with_values?: any, patient_id?: any): Observable<any> {
    let url = URLS.master.getMasterByAttrList;
    url = _.replace(url, "{slug}", slug);
    url = _.replace(url, "{w_val}", with_values ? with_values : '');
    url = _.replace(url, "{patient_id}", patient_id ? patient_id : '');
    url = url + '&slug=' + masterSlug;
    return this.request.getApi(url);
  }

  getCountryLists(): Observable<any> {
    let url = URLS.master.getCountryList;
    return this.request.getApi(url);
  }

  getMasterX(slug): Observable<any> {
    let url = URLS.master.getMasterx;
    url = _.replace(url, "{slug}", slug);
    return this.request.getApi(url);
  }

  getTimezoneX(): Observable<any> {
    let url = URLS.master.getTimezoneX;
    return this.request.getApi(url);
  }

  getSpecialityLists(s_type?: any): Observable<any> {
    let url = URLS.master.getSpecialityList;
    url = _.replace(url, "{s_type}", s_type ? s_type : null);
    return this.request.getApi(url);
  }

  getTimezoneLists(): Observable<any> {
    let url = URLS.master.getTimezoneList;
    return this.request.getApi(url);
  }

  getAutoCompletePatientsList(val, role): Observable<any> {
    let url = URLS.users.getUsersList + '?&searchkey=' + val + '&limit=35&role=' + role;
    return this.request.getApi(url);
  }

  getHospitalListAll(): Observable<any> {
    let url = URLS.hospital.getHospitalListAll;
    return this.request.getApi(url);
  }

  getHospitalEntityListAll(location_id?: string): Observable<any> {
    let lid = location_id ? location_id : '';
    let url = URLS.hospital.getHospitalListAll + '?location_id=' + lid;
    return this.request.getApi(url);
  }
}
